<div [ngClass]="{'mox-ui-page-container mox-ui-page-container-rm-pd-btm': claim.isMox()}">
  <div class="prev-bar">
    <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i>&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}}&nbsp;</a>
    <a (click)="back()" *ngIf="claim.isMox()" class="back-chevron"></a>
  </div>
  <div class="col-12">
    <h5>{{ 'claimSection.generalLabels.whatHappened' | translate}}</h5>
    <p [ngClass]="{'mox-ui-margin-bottom-0': claim.isMox()}">{{ 'claimSection.baggageDelay.detailsOfEmergencyItemsPurchased.title' | translate}}</p>
  </div>
  <div class="row col-12">
    <div class="col-xl-9 col-lg-12" [ngClass]="{'mox-ui-full-width mox-style-mg-bottom-140': claim.isMox()}">
      <form [formGroup]="emergencyPurchaseForm">
        <div formArrayName="items" *ngFor="let item of emergencyPurchaseForm.get('items')['controls']; let i = index;">
          <div [formGroupName]="i">   
              <div class="form-group click-more-content" id="q1" [ngClass]="{'mox-ui-position-relative mox-ui-mg-top-8': claim.isMox()}">
                <div [ngClass]="{'mox-ui-page-container mox-ui-page-container-rm-pd-btm mox-ui-page-container-rm-pd-top mox-ui-position-relative mox-ui-width-100per': claim.isMox()}">
                <label [ngClass]="{'mox-ui-section-mg-btm': claim.isMox()}">{{'claimSection.baggageDelay.detailsOfEmergencyItemsPurchased.item' | translate}} &nbsp; {{i+1}}</label><button [hidden]="i==0" class="removeBtn" (click)="removeItem(i)" [ngClass]="{'mox-ui-btn mox-ui-mg-bottom-10 mox-ui-btn-remove-absolute-right mox-ui-btn-items mox-ui-remove-item': claim.isMox()}">{{'claimSection.baggageDelay.detailsOfEmergencyItemsPurchased.remove' | translate}}</button><BR>
                <qnect-ui [fieldId]="'TRAVEL_BAG_DEL10'"
                          [frmArrayGroup]="emergencyPurchaseForm"
                          [frmArrayName]="'items'"
                          frmArrayIndex="{{i}}"
                          name="emergencyPurchaseType"></qnect-ui>
                </div>
              </div>
              <div *ngIf="(this.emergencyPurchasedItemsArray !== null && this.emergencyPurchasedItemsArray.length > 0) && this.emergencyPurchasedItemsArray[i]?.getEmergencyPurchaseType()">
                <div [ngClass]="{'mox-ui-page-container mox-ui-page-container-rm-pd-btm mox-ui-page-container-rm-pd-top mox-ui-width-100per': claim.isMox()}">  
                <div class="form-group" *ngIf="this.emergencyPurchasedItemsArray[i].getEmergencyPurchaseType() === 'Others'">
                      <qnect-ui [fieldId]="'TRAVEL_BAG_DEL11'"
                                [frmArrayGroup]="emergencyPurchaseForm"
                                [frmArrayName]="'items'"
                                frmArrayIndex="{{i}}"
                                name="emergencyPurchaseTypeDetail"></qnect-ui>
                  </div>
                  <div class="form-group">
                      <qnect-ui [fieldId]="'TRAVEL_BAG_DEL12'"
                                [frmArrayGroup]="emergencyPurchaseForm"
                                [frmArrayName]="'items'"
                                frmArrayIndex="{{i}}"
                                [aboveMaxDateValidator]="claim.getClaimTravel().getOriginalReturnDate()"
                                name="purchaseDate"></qnect-ui>
                  </div>
                  <div class="form-group">
                      <qnect-ui [fieldId]="'TRAVEL_BAG_DEL13'"
                                [frmArrayGroup]="emergencyPurchaseForm"
                                [frmArrayName]="'items'"
                                frmArrayIndex="{{i}}"
                                name="purchasePrice"></qnect-ui>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-12 hide">
                  &nbsp;
              </div>              
          </div>
        </div>
      </form>
      <div [ngClass]="{'mox-ui-page-container mox-ui-page-container-rm-pd-top mox-ui-page-container-rm-pd-btm': claim.isMox()}">
      <div class="addFile" (click)="addItem()" [ngClass]="{'mox-ui-font-size-14 mox-ui-mg-top-8 mox-ui-add-file': claim.isMox()}">
        <i class="fas fa-plus" *ngIf="!claim.isMox()"></i>
        <img src="assets/images/Add.svg" alt="plus" class="plus-img" *ngIf="claim.isMox()"/>
        <span>{{'claimSection.baggageDelay.detailsOfEmergencyItemsPurchased.addItem' | translate}}</span>
      </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-12" [ngClass]="{'mox-ui-full-width': claim.isMox()}">
      &nbsp;
    </div>
  </div>

  <div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" [hidden]="claim.isMox()" class="Tertiary"> {{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn new-btn btn-primary float-right">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right" ></i></button>
  </div>
  <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>
